<template>
  <div class="section-main__warp plan">
    <ioc-table
      v-model="plan"
      :data="tableData"
      :option="option"
      :page="page"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-auth="'/assetsManage/plan:add'"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAdd"
        >
          {{ $t("workGroup.button.add") }}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/assetsManage/plan:update'"
            icon="iconfont icon-Edit"
            @click="handleEdit(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/assetsManage/plan:delete'"
            icon="el-icon-delete"
            @click="handleDel(scope.row)"
          ></el-button>
        </el-tooltip>
      </template>
    </ioc-table>
    <el-dialog
      :title="title"
      v-if="visible"
      :visible.sync="visible"
      width="500px"
      class=""
    >
      <el-form
        ref="dialogForm"
        v-if="title !== '详情'"
        :model="planForm"
        label-width="110px"
        :rules="rules"
      >
        <el-form-item label="巡检计划名称" prop="planName">
          <el-input
            v-model="planForm.planName"
            placeholder="请输入巡检计划名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="巡检周期" prop="planCycle">
          <el-select
            v-model="planForm.planCycle"
            clearable
            style="width:100%"
            placeholder="请选择巡检周期"
            @change="handleSelectChange"
          >
            <el-option
              v-for="item in planCycleList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检时间" prop="cycleTimeList" class="patrolItem">
          <el-tag
            :key="tag"
            v-for="(tag, index) in planForm.cycleTimeList"
            closable
            :disable-transitions="false"
            @close="handleTagClose(index)"
          >
            {{ tag.startTime + " - " + tag.endTime }}
          </el-tag>
          <picker
            v-if="inputVisible && planForm.planCycle === 1"
            style="width: 200px; margin-bottom: 8px"
            @change="handleSelectConfirm"
          ></picker>
          <el-time-picker
            is-range
            v-if="inputVisible && planForm.planCycle === 2"
            v-model="inputValue"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="HH:mm:ss"
            format="HH:mm:ss"
            style="width:100%"
            @change="handleInputConfirm"
            @blur="handleInputConfirm"
          ></el-time-picker>
          <el-date-picker
            v-model="inputValue"
            v-if="inputVisible && planForm.planCycle === 3"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            format="yyyy-MM-dd HH:mm:ss"
            end-placeholder="结束日期"
            style="width: 400px"
            @change="handleInputConfirm"
            @blur="handleInputConfirm"
          >
          </el-date-picker>
          <div
            v-if="!inputVisible"
            :class="[
              'button-new-tag',
              planForm.cycleTimeList.length === 0 ? '' : 'tagFlag'
            ]"
            @click="showInput"
          >
            +
          </div>
        </el-form-item>
      </el-form>
      <div class="planInfo" v-else>
        <div class="planInfo-list">
          <label>巡检计划名称：</label>
          <div>{{ planForm.planName }}</div>
        </div>
        <div class="planInfo-list">
          <label>巡检周期：</label>
          <div>{{ planForm.planCycle }}</div>
        </div>
        <div class="planInfo-list" style="width: 100%">
          <label style="margin-bottom: 8px">巡检时间：</label>
          <div class="patrolItem" style="flex: 1; flex-wrap: wrap">
            <el-tag
              :key="tag"
              v-for="tag in planForm.cycleTimeList"
              :disable-transitions="false"
            >
              {{ tag.startTime + " - " + tag.endTime }}
            </el-tag>
          </div>
        </div>
      </div>
      <template #footer v-if="title !== '详情'">
        <div class="dialog-footer">
          <el-button type="info" @click="handleClose"
            >{{ $t("accountGroup.button.cancel") }}
          </el-button>
          <el-button type="primary" @click="handleSave"
            >{{ $t("accountGroup.button.save") }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import option from "../const/plan";
import utils from "@src/common/utils";

export default {
  name: "plan",
  data() {
    return {
      inputVisible: false,
      inputValue: "",
      title: "新增",
      planCycleList: utils.Dic.find("SENU106") || [],
      planForm: {
        planName: "",
        planCycle: "",
        cycleTimeList: []
      },
      rules: {
        planName: [
          { required: true, message: "请输入巡检计划名称", trigger: "blur" }
        ],
        planCycle: [
          { required: true, message: "请选择巡检周期", trigger: "blur" }
        ]
      },
      visible: false,
      plan: {
        areaList: ""
      },
      tableData: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10
      },
      option: option
    };
  },
  mounted() {
    this.getList();
  },
  created() {},
  computed: {},
  methods: {
    handleSelectChange() {
      this.inputVisible = true;
      this.planForm.cycleTimeList = [];
    },
    handleView(item) {
      this.visible = true;
      this.title = "详情";
      this.planForm = {
        planName: item.planName,
        planCycle: utils.Dic.findByValue("SENU106", item.planCycle),
        cycleTimeList: item.cycleTimeList
      };
    },
    handleEdit(item) {
      this.visible = true;
      this.title = "修改";
      this.planForm = {
        planName: item.planName,
        planCycle: Number(item.planCycle),
        cycleTimeList: item.cycleTimeList
      };
      this.planForm.planCode = item.planCode;
    },
    handleClose() {
      this.inputVisible = false;
      this.visible = false;
    },
    handleSave() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          if (this.title === "新增") {
            this.$fetch(api.assetsManage.addPlanInfo, this.planForm).then(
              (res) => {
                if (res && res.success) {
                  this.handleClose();
                  this.getList();
                  this.$message.success("新增成功");
                } else {
                  this.$message.error(res.msgContent);
                }
              }
            );
          } else {
            this.$fetch(api.assetsManage.updatePlanInfo, this.planForm).then(
              (res) => {
                if (res && res.success) {
                  this.handleClose();
                  this.getList();
                  this.$message.success("修改成功");
                } else {
                  this.$message.error(res.msgContent);
                }
              }
            );
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleTagClose(index) {
      this.planForm.cycleTimeList.splice(index, 1);
    },
    showInput() {
      this.inputVisible = true;
    },
    handleSelectConfirm(arr) {
      this.planForm.cycleTimeList.push({
        startTime: arr[0] + "",
        endTime: arr[1] + ""
      });
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleInputConfirm() {
      let inputValue = this.inputValue;
      if (inputValue && inputValue.length > 0) {
        this.planForm.cycleTimeList.push({
          startTime: inputValue[0] + "",
          endTime: inputValue[1] + ""
        });
      }
      this.inputVisible = false;
      this.inputValue = "";
    },
    handleSearchReset() {
      this.getList();
    },
    getList() {
      const params = {
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$fetch(api.assetsManage.queryPlan, params).then((response) => {
        setTimeout(() => {
          loading.close();
        }, 500);
        if (!response.success) {
          this.$message.error(response.msgContent);
        } else {
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.list])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
        }
      });
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleAdd() {
      this.visible = true;
      this.inputVisible = true;
      this.title = "新增";
      this.planForm = {
        planName: "",
        planCycle: "",
        cycleTimeList: []
      };
    },
    handleDel(row) {
      const params = {
        planCodeList: [row.planCode]
      };
      this.$confirm("您确定删除该巡检计划吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$fetch(api.assetsManage.deletePlan, params).then((response) => {
          if (response && response.success) {
            this.$message.success("删除成功");
            this.getList();
          } else {
            this.$message.error(response.msgContent);
          }
        });
      });
    }
  }
};
</script>
<style lang="scss">
.planInfo {
  display: flex;
  flex-wrap: wrap;
  height: 100%;

  .planInfo-list {
    display: flex;
    align-items: center;
    width: 50%;
    padding: 5px 0;
    margin-top: 10px;
  }
}

.plan {
  .patrolItem {
    display: flex;

    .tagFlag {
      margin-bottom: 8px;
    }

    .el-tag {
      height: 32px;
      line-height: 32px;
      // background: #0c316b;
      // border: 1px solid #264788;
      border-radius: 1px;
      margin-right: 10px;
      margin-bottom: 8px;
      // color: #fff;
    }

    .el-form-item__content {
      margin-left: 0 !important;
      flex: 1;
      width: 0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .button-new-tag {
      height: 20px;
      cursor: pointer;
      width: 20px;
      // background: #2a5094;
      display: flex;
      align-items: center;
      justify-content: center;
      // color: #0a2248;
      border-radius: 50%;
      font-size: 24px;
    }

    .input-new-tag {
      width: 200px;
      margin-bottom: 8px;
      cursor: pointer;
    }
  }
}
</style>
